export default __webpack_public_path__ + "static/media/absolute.71852235.png";